var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "availability badge", class: _vm.classes },
    [
      _vm.availability == 1
        ? [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$translate("Ecomsilio::Template.availability1")) +
                "\n  "
            ),
          ]
        : _vm.availability == 5
        ? [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$translate("Ecomsilio::Template.availability5")) +
                "\n  "
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }